export default "__VITE_ASSET__6cdf4d29__"